module.exports = __webpack_public_path__ + "img/tienda-bujin.f760b602.png";